<template>
  <div>
    <div class="vx-row mt-2">
      <div class="vx-col w-full">
        <vs-button 
          v-if="!isResourceViewActive && !isBackButtonHidden"
          style="border-radius: 15px"
          @click="backToSelect"
          icon-pack="feather"
          icon="icon-arrow-left"
          class="back__button-with-border float-left mb-3 school-primary_gradient glow-effect_primary">
          Back
        </vs-button> 
      </div>
    </div>
    <div class="vx-row pb-2" style="justify-content: space-evenly;" v-show="isViewActiveLocal && isResourceViewActive">
      <div class="vx-col w-full lg:w-1/4 sm:w-1/2 mb-base">
        <vx-card class="overlay-card overflow-hidden library-content-cards" @click="showDocuments">
          <template slot="no-body">
            <img src="./assets/document.jpg" class="responsive"> 
          </template>
          <div class="library-card-heading">
            Documents
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full lg:w-1/4 sm:w-1/2 mb-base">
        <vx-card class="overlay-card overflow-hidden library-content-cards" @click="showVideos">
          <template slot="no-body">
            <img src="./assets/video.jpg" class="responsive">              
          </template>
          <div class="library-card-heading">
            Videos
          </div>
        </vx-card>
      </div>   
      <div class="vx-col w-full lg:w-1/4 sm:w-1/2 mb-base">
        <vx-card class="overlay-card overflow-hidden library-content-cards" @click="showPodcasts">
          <template slot="no-body">
            <img src="./assets/podcast.png" class="responsive">              
          </template>
          <div class="library-card-heading">
            Podcasts
          </div>
        </vx-card>
      </div>         
    </div>     
    <document-view
      :isCardActive="isDocumentViewActive"
      @hideBackButton="isBackButtonHidden = true"
      @showBackButton="isBackButtonHidden = false"
      :modulesList="modulesList"
    />
    <video-view
      :isCardActive="isVideoViewActive"
      @hideBackButton="isBackButtonHidden = true"
      @showBackButton="isBackButtonHidden = false"
      :modulesList="modulesList"
    />
    <podcast-view
      :isCardActive="isPodcastsViewActive"
      @hideBackButton="isBackButtonHidden = true"
      @showBackButton="isBackButtonHidden = false"
      :modulesList="modulesList"
    />
  </div>
</template>

<script>
  import DocumentView from './multimediacomponents/Document.vue';
  import VideoView from './multimediacomponents/Video.vue';
  import PodcastView from './multimediacomponents/Podcast.vue';

  export default {
    props: {
      isViewActive: {
        required: false,
      },
      modulesList: {
        required: false
      }
    },
    components: {
      DocumentView,
      VideoView,
      PodcastView,
    },
    data() {
      return {
        isResourceViewActive: true,
        isDocumentViewActive: false,
        isVideoViewActive: false,
        isPodcastsViewActive: false,
        isInfoHidden: true,
        componentKey: 0,
        isBackButtonHidden: false
      }
    },
    watch: {
      isViewActive: function (val) {
        if(val){
          
        }
      }
    },
    computed: {
      isViewActiveLocal: {
        get() {
          return this.isViewActive;
        }
      },
    },
    methods: {
      showDocuments(){
        this.componentKey += 1;
        this.isDocumentViewActive = true;
        this.isResourceViewActive = false;
      },
      showVideos(){
        this.componentKey += 1;
        this.isVideoViewActive = true;
        this.isResourceViewActive = false;
      },
      showPodcasts(){
        this.componentKey += 1;
        this.isPodcastsViewActive = true;
        this.isResourceViewActive = false;
      },
      backToSelect(){
        this.isDocumentViewActive = false;
        this.isVideoViewActive = false;
        this.isPodcastsViewActive = false;
        this.isResourceViewActive = true;
      }
    }
  }

</script>

<style lang="scss">
.cropper-div {
  input[type="file"] {
    display: none;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 0 5px 0;
  }
  .header h2 {
    margin: 0;
  }
  .header a {
    text-decoration: none;
    color: black;
    
  }
  .cropper-area_tool {
    width: 60%;
  }
  .cropper-area_buttons {
    width: 100%;
  }
  .actions {
    margin-top: 1rem;
    display: flex;
  }
  textarea {
    width: 100%;
    height: 100px;
  }
  .preview-area {
    width: 307px;
  }
  .preview-area p {
    font-size: 1.25rem;
    margin: 0;
    margin-bottom: 1rem;
  }
  .preview-area p:last-of-type {
    margin-top: 1rem;
  }
  .preview {
    width: 100%;
    height: calc(372px * (9 / 16));
    overflow: hidden;
  }
  .crop-placeholder {
    width: 100%;
    height: 200px;
    background: #ccc;
  }
  .cropped-image img {
    max-width: 100%;
  }
}
</style>
